<template>
  <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
    <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-skeleton-loader v-if="isInitialLoading" type="text" class="mt-5" :loading="true"
        ></v-skeleton-loader>
      <v-skeleton-loader v-if="isInitialLoading" type="card" class="mt-5" :loading="true"
       ></v-skeleton-loader>
      <v-data-table :headers="headers" :items="ibDetails" :items-per-page="5" hide-default-footer>
        <template v-slot:item.name="{ item }">
          <router-link v-if="$canRoute('top-performed-ib') === 1" class="text-capitalize text--ash" :to="`/registered-user-details/${item.ib_id}`">
            {{ item.name }}
          </router-link>
          <span v-else class="text-capitalize text--ash">{{ item.name }}</span>
        </template>
        <template v-slot:item.total_business="{ item }">
          {{ Number(item.total_business).toFixed(2) }}
        </template>

        <template v-slot:item.details="{ item }">
          <router-link class="links text-decoration-none"
            :to="{ path: '/partner-list-details', query: { id: item.ib_id } }">
            <v-icon color="#039de9" small>mdi-eye-outline</v-icon>
          </router-link>
        </template>
      </v-data-table>
    </v-sheet>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { IBREQUEST__ACTIONS } from "@/store/action-types";
export default {
  name: 'TransactionDummyTable',
  data() {
    return {
      search: "",
      headers: [
        { text: "IB ID", value: "ib_id" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Total Clients", value: "total_clients" },
        { text: "Total Business", value: "total_business" },
        { text: "New Clients", value: "new_clients" },
        { text: "Trading Volume", value: "total_trading_volume" },
        { text: "Commission Earning", value: "total_commission_earning" },
        { text: "Total Trade", value: "total_trade" },
        { text: "Performance Score", value: "performance_score" },
      ],
    };
  },
  computed: {
    ...mapState("ibrequest", ["ibDetails", "isLoading"]),
    loading() {
      return this.isLoading;
    }
  },
  methods: {
    ...mapActions("ibrequest", [IBREQUEST__ACTIONS.TOPIBDETAILS]),
    async fetchibDetails() {
      await this[IBREQUEST__ACTIONS.TOPIBDETAILS]({
        page: 1,
        limit: 5,
        search: this.search || "",
        filter_by: this.expenseShorting || ""
      });
    },
  },

  created() {
    this.fetchibDetails();
    if (this.$canRoute('top-performed-ib') === 1) {
      this.headers.push({ text: "Details", value: "details" });
    }
  }
};
</script>
